import React, { useState } from 'react';

const BASE = 'https://ssparfurmerie.com';

export default function ProductImage({ images, name, height = 200, style = {} }) {
  const [errored, setErrored] = useState(false);
  const src = images?.[0];
  const url = src ? (src.startsWith('http') ? src : BASE + src) : null;

  if (!url || errored) {
    return (
      <div style={{
        height, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        background: 'linear-gradient(135deg, #F3F0FF, #EDE9FE)',
        color: '#C4B5FD', gap: 8, ...style
      }}>
        <span style={{ fontSize: height * 0.25 }}>🧴</span>
        <span style={{ fontSize: 10, letterSpacing: 1, color: '#C4B5FD', fontFamily: 'Montserrat, sans-serif' }}>
          {name?.substring(0, 20)}
        </span>
      </div>
    );
  }

  return (
    <img
      src={url}
      alt={name}
      onError={() => setErrored(true)}
      style={{
        width: '100%', height, objectFit: 'cover',
        display: 'block', ...style
      }}
    />
  );
}
